export interface RRStatusBarModel {
  text: string;
  class: string;
  order: number;
  isActive: boolean;
  isLast?: boolean;
  showTick?: boolean;
  isLastActive?: boolean;
  tooltip?: string;
}
